import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { useStyle } from "./styles";

function Tag({ text, color, tooltip, onClick }) {
  const style = useStyle();
  return (
    <Tooltip title={tooltip} arrow placement="left" onClick={onClick}>
      <span className={style[color]}>{text}</span>
    </Tooltip>
  );
}

export default Tag;
